import { render, staticRenderFns } from "./pendWarning.vue?vue&type=template&id=35d0143a&scoped=true&"
import script from "./pendWarning.vue?vue&type=script&lang=js&"
export * from "./pendWarning.vue?vue&type=script&lang=js&"
import style0 from "./pendWarning.vue?vue&type=style&index=0&id=35d0143a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d0143a",
  null
  
)

component.options.__file = "pendWarning.vue"
export default component.exports